import { useFeatureFlag } from 'contexts/configcat/useFeatureFlag';
import { usePermissions } from 'contexts/PermissionsContext';
import { Control } from 'react-hook-form';
import styled from 'styled-components';
import { truthySet } from 'utils/array';

import { ProfileSection } from '../components';
import { AppearanceOption, AppearanceSubSection } from './AppearanceSubSection';
import {
    OptionalFeature,
    OptionalFeaturesSubSection,
} from './OptionalFeaturesSubSection';
import { UserSettingsFormData } from './UserProfileModal';

const StyledProfileSection = styled(ProfileSection)`
    display: flex;
    flex-direction: column;
    justify-content: left;
    gap: 0.6rem;
`;

export type OptionalFeaturesPaneProps = Readonly<{
    control: Control<UserSettingsFormData>;
    className?: string;
}>;

export function OtherPreferencesPane({ control, className }: OptionalFeaturesPaneProps) {
    const { canSwitchEnvironment } = usePermissions();

    const allowedAppearanceFeatures = truthySet<AppearanceOption>(
        useFeatureFlag('hasThemes').value && 'theme',
    );
    const allowedOptionalFeatures = truthySet<OptionalFeature>(
        canSwitchEnvironment && 'envSwitcher',
    );

    if (allowedAppearanceFeatures.size === 0 && allowedOptionalFeatures.size === 0) {
        return null;
    }

    return (
        <StyledProfileSection className={className} title="Other Preferences">
            <AppearanceSubSection
                control={control}
                allowedFeatures={allowedAppearanceFeatures}
            />
            <OptionalFeaturesSubSection
                control={control}
                allowedFeatures={allowedOptionalFeatures}
            />
        </StyledProfileSection>
    );
}
